module.exports = __webpack_public_path__ + "static/media/down-arrow.d59f3700.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/down-arrow.svg
// module id = 770
// module chunks = 0